/**
 * @license
 * Copyright Moda Operandi. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/ModaOperandi/mo-tools-engine/blob/master/LICENSE
 */

// --- Interceptors ---

export { AuthInterceptorProvider } from './auth-interceptor';

// --- Service Configuration Objects ---

/*
 * Imported for type annotations in host app
 */
export { CsrfConfig }              from './tokens/csrf-config';

// --- Components ---

/*
 * Export Components here in addition to adding it to declarations array of AuthModule so that
 * host applications can access their selectors.
 */

export { LoginComponent }          from './login-logout/login.component';
export { LogoutComponent }         from './login-logout/logout.component';

// --- Services ---

/*
 * Export AuthErrorStateService here in addition to adding it to the declarations array of AuthModule so that
 * tools components can import it to listen to authentication errors on login.
 */

export { AuthErrorStateService }   from './error-handlers/auth-error-state.service';

